import { useEffect, useState } from 'react';

/**
 * De waarde zoals ze er na `ms` milliseconden stilte bij staat (story 12, S7: "uitgesteld, niet per
 * toets").
 *
 * De eerste waarde komt meteen terug, zodat het effect van de beginwaarde bij het laden al gevraagd
 * wordt. Daarna wint alleen de waarde waarna niemand meer typte: wie "30" typt, vraagt nooit iets
 * over "3".
 */
export function useUitgesteld<T>(waarde: T, ms = 300): T {
  const [uitgesteld, setUitgesteld] = useState(waarde);
  useEffect(() => {
    const klok = setTimeout(() => setUitgesteld(waarde), ms);
    return () => clearTimeout(klok);
  }, [waarde, ms]);
  return uitgesteld;
}
